import { AccountInfo, AuthenticationResult, EventMessage, EventType, IPublicClientApplication } from "@azure/msal-browser";
import { useEffect, useState } from "react";

export const sameAccount = (a: AccountInfo | null, b: AccountInfo | null) =>
  a?.homeAccountId === b?.homeAccountId && a?.tenantId === b?.tenantId;

const useActiveAccount = (pca: IPublicClientApplication) => {
  const [account, setAccount] = useState<AccountInfo | null>(
    () => pca.getActiveAccount() ?? pca.getAllAccounts()[0] ?? null);

  useEffect(() => {
    const syncFromActiveAccount = () => {
      const next = pca.getActiveAccount() ?? null;
      setAccount(current => sameAccount(current, next) ? current : next);
    };

    if (!pca.getActiveAccount()) {
      const first = pca.getAllAccounts()[0] ?? null;
      if (first) pca.setActiveAccount(first);
    }
    syncFromActiveAccount();

    const callbackId = pca.addEventCallback((event: EventMessage) => {
      switch (event.eventType) {
        case EventType.ACQUIRE_TOKEN_SUCCESS: {
          const result = event.payload as AuthenticationResult;
          if (result?.account && !sameAccount(pca.getActiveAccount(), result.account)) {
            pca.setActiveAccount(result.account);
          }
          syncFromActiveAccount();
          break;
        }
        case EventType.ACTIVE_ACCOUNT_CHANGED:
        case EventType.LOGOUT_SUCCESS:
          syncFromActiveAccount();
          break;
      }
    });

    return () => {
      if (callbackId) pca.removeEventCallback(callbackId);
    };
  }, [pca]);

  return account;
};

export default useActiveAccount;
